type CsvRow = Record<string, unknown>

const escapeCell = (value: unknown): string => {
  const str = value == null ? '' : String(value)
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
}

// Serialize an array of flat objects to CSV, using the first row's keys as headers.
export const toCsv = (rows: CsvRow[]): string => {
  if (!rows || !rows.length) return ''
  const headers = Object.keys(rows[0])
  return [headers.join(','), ...rows.map(row => headers.map(header => escapeCell(row[header])).join(','))].join('\n')
}

export const downloadCsv = (rows: CsvRow[], filename: string): void => {
  // Prepend a UTF-8 BOM so Excel reads non-ASCII correctly (react-csv did this by default).
  const blob = new Blob(['﻿' + toCsv(rows)], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
